import React, { Component } from "react";
import { connect } from "react-redux";
import { shape, func, bool } from "prop-types";

import { actions as communicationActions, selectors as communicationSelectors } from "reducers/communication";

import {
    applyEmbeddedV3ShellLayoutState,
    clearEmbeddedV3ShellLayoutState,
    isUxDashboardImprovementsEnabled,
} from "util/v3ShellLayoutSync";

import Compose from "pages/communications/_components/Compose";
import MainContainer from "pages/_components/MainContainer";
import Head from "pages/_components/Head";

class ReplyMessage extends Component {
    static propTypes = {
        dispatch: func.isRequired,
        match: shape().isRequired,
        detail: shape().isRequired,
        history: shape().isRequired,
        isDesktop: bool.isRequired,
        embeddedInV3Shell: bool,
    };

    static defaultProps = {
        embeddedInV3Shell: false,
    };

    componentDidMount() {
        const { match, dispatch } = this.props;

        dispatch(communicationActions.detailRequest(match.params.id));
        this.syncEmbeddedV3ShellLayout();
    }

    componentDidUpdate(prevProps) {
        const { embeddedInV3Shell, isDesktop, detail, match } = this.props;
        if (
            embeddedInV3Shell &&
            (prevProps.embeddedInV3Shell !== embeddedInV3Shell ||
                prevProps.isDesktop !== isDesktop ||
                prevProps.detail !== detail ||
                prevProps.match.params.id !== match.params.id)
        ) {
            this.syncEmbeddedV3ShellLayout();
        }
    }

    componentWillUnmount() {
        const { dispatch, embeddedInV3Shell } = this.props;
        if (embeddedInV3Shell) {
            clearEmbeddedV3ShellLayoutState(dispatch);
        }
    }

    syncEmbeddedV3ShellLayout = () => {
        const { dispatch, embeddedInV3Shell, isDesktop, detail, match } = this.props;
        const subject = detail && detail[0] ? detail[0].subject : "";
        const readBackPath = `/communications/read/${match.params.id}`;
        applyEmbeddedV3ShellLayoutState(dispatch, {
            embeddedInV3Shell,
            isDesktop,
            scopes: ["communications"],
            goBackPath: readBackPath,
            ...(subject ? { headerTitle: subject } : { titleKey: "chat.title" }),
        });
    };

    handleBackClick = () => {
        const { history } = this.props;

        history.goBack();
    };

    render() {
        const { detail, isDesktop, embeddedInV3Shell } = this.props;

        if (!detail) {
            return null;
        }

        const hideLegacyMobileHead = embeddedInV3Shell && isUxDashboardImprovementsEnabled() && !isDesktop;

        return (
            <>
                {!hideLegacyMobileHead && (
                    <Head
                        titleText={detail[0].subject}
                        onBack={this.handleBackClick}
                        closeLinkTo="/communications"
                        closeImageWhite
                        titleClassName={!isDesktop && "header-mobile-title-background-blue"}
                        headerClassName={!isDesktop && "blue-main-header-mobile"}
                    />
                )}
                <MainContainer>
                    <Compose isReply />
                </MainContainer>
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    detail: communicationSelectors.detail(state),
});

export default connect(mapStateToProps)(ReplyMessage);
